/**
 * Where a project's tasks live: under its location, or, when that location is
 * gone, at the project's own page (MYD-624).
 *
 * A project's populated `projectAsset` is null once its location has been
 * deleted. The Home screens read `projectAsset._id` while mapping the project
 * list, so one such project blanked the whole dashboard.
 */
export const projectTasksPath = (project: { _id: string; projectAsset?: { _id?: string } | null }): string =>
	project.projectAsset?._id ? `/locations/${project.projectAsset._id}/projects/${project._id}/tasks` : `/projects/${project._id}`

export default projectTasksPath
